import React, { useContext } from 'react'
import { FormattedMessage } from 'react-intl'
import FadeIn from '../../../components/Animation/FadeIn'
import PaddingContext from '../../../utils/PaddingContext'

const HowItWorks = () => {
    const { padding } = useContext(PaddingContext)
    return (
        <div className='py-12 md:py-30 relative 3xl:max-w-screen-2xl mx-auto'>
            <FadeIn>
                <div
                    className='side-padding flex md:flex-row flex-col items-center justify-between gap-y-8 md:gap-y-0'
                    style={{ ...padding }}
                >
                    <div className='md:max-w-[520px]'>
                        <FormattedMessage id='page.partnerships.howItWorks' tagName='h2' />
                    </div>
                    <div className='md:max-w-[410px]'>
                        {' '}
                        <FormattedMessage id='page.partnerships.howItWorks.description' tagName='p' />
                    </div>
                </div>
            </FadeIn>
        </div>
    )
}

export default HowItWorks
